import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { Alert } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { loadEmailBounces, deleteEmailBounce } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';

class EmailBounces extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		if (this.props.isRestrictedUser) {
			return;		// the API forbids the request - don't fire it just to show an error
		}

		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	reloadData() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleDelete(id) {
		const onSuccessEvent = () => this.reloadData();
		this.props.deleteEmailBounce(id, onSuccessEvent);
	}

	render() {
		const { isReadonly, isRestrictedUser, t } = this.props;

		// the menu item is hidden for these users, but the route still resolves if the URL is typed in
		if (isRestrictedUser) {
			return <Alert bsStyle='info'>{t('EmailBounces_NoAccessForRestrictedUser')}</Alert>;
		}

		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading}/>
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} onDelete={this.handleDelete} data={this.props.data} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { emailBounces },
		auth: { currentUser }
	} = state;

	const emailBouncesPagination = pagination.emailBounces.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: emailBouncesPagination.ids.map(id => emailBounces[id]),
		pagination: emailBouncesPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'EmailBounces'),
		isRestrictedUser: currentUser.isCenterRestricted || currentUser.isFranchiseeRestricted
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadEmailBounces,
	deleteEmailBounce,
	initializeFilter: (data, fields) => initialize('emailBouncesFilter', data, fields)
})(withTranslation()(EmailBounces));